/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */

export type NotificationCategoryType = typeof NotificationCategoryType[keyof typeof NotificationCategoryType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationCategoryType = {
  LOAN_REMINDER: 'LOAN_REMINDER',
  LOAN_OVERDUE: 'LOAN_OVERDUE',
  GENERAL_MEETING: 'GENERAL_MEETING',
  PRODUCT_CHANGE: 'PRODUCT_CHANGE',
  INTEREST_RATE_CHANGE: 'INTEREST_RATE_CHANGE',
  PROMOTIONAL: 'PROMOTIONAL',
  SYSTEM_ALERT: 'SYSTEM_ALERT',
  ACCOUNT_ACTIVITY: 'ACCOUNT_ACTIVITY',
  GENERAL: 'GENERAL',
} as const;
